const errorHandler = {
    data() {
        return {
            errorMessage: null,
        };
    },
    methods: {
        handleResponseError(error) {
            if (error) {
                if (error.response) {
                    if (error.response.status === 403) {
                        this.$router.push('/not-allowed');
                    } else {
                        if (error.response.data.errors.message[0]) {
                            this.errorMessage = error.response.data.errors.message[0];
                        } else {
                            this.errorMessage = error.response.data.errors.text[0];
                        }
                        if (this.$refs.alert) {
                            this.$refs.alert.showAlert();
                        }
                    }
                    // this.errorMessage = Object.values(error.response.data.errors).flat().join('. ');
                } else {
                    if (error.data.errors.message[0]) {
                        this.errorMessage = error.data.errors.message[0];
                    } else {
                        this.errorMessage = error.data.errors.text[0];
                    }
                    if (this.$refs.alert) {
                        this.$refs.alert.showAlert();
                    }
                }
            }
        },
    },
};

export default errorHandler;
